import { render, staticRenderFns } from "./suggestion-chips.vue?vue&type=template&id=4faa2ad4&scoped=true&"
import script from "./suggestion-chips.vue?vue&type=script&lang=js&"
export * from "./suggestion-chips.vue?vue&type=script&lang=js&"
import style0 from "./suggestion-chips.vue?vue&type=style&index=0&id=4faa2ad4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faa2ad4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4faa2ad4')) {
      api.createRecord('4faa2ad4', component.options)
    } else {
      api.reload('4faa2ad4', component.options)
    }
    module.hot.accept("./suggestion-chips.vue?vue&type=template&id=4faa2ad4&scoped=true&", function () {
      api.rerender('4faa2ad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/suggestion-chips/suggestion-chips.vue"
export default component.exports